type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  fillColor?: string;
};

const MicrophoneIcon = (props: Props) => {
  const {
    width = '12',
    height = '13',
    viewBox = '0 0 12 13',
    fillColor = '#F3E9D7',
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      <g clipPath="url(#clip0_31053_2478)">
        <path
          d="M6 8.75C6.59655 8.74938 7.16848 8.51213 7.59031 8.09031C8.01213 7.66848 8.24938 7.09655 8.25 6.5V3.5C8.25 2.90326 8.01295 2.33097 7.59099 1.90901C7.16903 1.48705 6.59674 1.25 6 1.25C5.40326 1.25 4.83097 1.48705 4.40901 1.90901C3.98705 2.33097 3.75 2.90326 3.75 3.5V6.5C3.75062 7.09655 3.98787 7.66848 4.4097 8.09031C4.83152 8.51213 5.40345 8.74938 6 8.75ZM4.5 3.5C4.5 3.10218 4.65804 2.72064 4.93934 2.43934C5.22064 2.15804 5.60218 2 6 2C6.39782 2 6.77936 2.15804 7.06066 2.43934C7.34196 2.72064 7.5 3.10218 7.5 3.5V6.5C7.5 6.89782 7.34196 7.27936 7.06066 7.56066C6.77936 7.84196 6.39782 8 6 8C5.60218 8 5.22064 7.84196 4.93934 7.56066C4.65804 7.27936 4.5 6.89782 4.5 6.5V3.5ZM6.375 10.2313V11.75C6.375 11.8495 6.33549 11.9448 6.26517 12.0152C6.19484 12.0855 6.09946 12.125 6 12.125C5.90054 12.125 5.80516 12.0855 5.73484 12.0152C5.66451 11.9448 5.625 11.8495 5.625 11.75V10.2313C4.70046 10.1372 3.84364 9.70361 3.22024 9.0144C2.59684 8.3252 2.25114 7.42932 2.25 6.5C2.25 6.40054 2.28951 6.30516 2.35984 6.23484C2.43016 6.16451 2.52554 6.125 2.625 6.125C2.72446 6.125 2.81984 6.16451 2.89016 6.23484C2.96049 6.30516 3 6.40054 3 6.5C3 7.29565 3.31607 8.05871 3.87868 8.62132C4.44129 9.18393 5.20435 9.5 6 9.5C6.79565 9.5 7.55871 9.18393 8.12132 8.62132C8.68393 8.05871 9 7.29565 9 6.5C9 6.40054 9.03951 6.30516 9.10983 6.23484C9.18016 6.16451 9.27554 6.125 9.375 6.125C9.47446 6.125 9.56984 6.16451 9.64017 6.23484C9.71049 6.30516 9.75 6.40054 9.75 6.5C9.74886 7.42932 9.40316 8.3252 8.77976 9.0144C8.15636 9.70361 7.29954 10.1372 6.375 10.2313Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_31053_2478">
          <rect width="12" height="12" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MicrophoneIcon;
